import CircularProgress from '@material-ui/core/CircularProgress'
import React, { FC } from 'react'

export const TinyCircularProgress: FC = () => {
  return <CircularProgress size={24} style={{ color: '#ccc' }} />
}
